module.exports = __webpack_public_path__ + "img/pro_07.f3beab42.jpg";